/**
 * Bitget frontend-модели для нативных операций.  Зеркало BybitNative.model.ts
 * (Bitget USDT-FUTURES ведёт себя как Bybit linear: positionIdx-число,
 * Buy/Sell, лимит/маркет).  Общий HedgeModeType переиспользуем из Bybit-модели,
 * чтобы не плодить дубль-экспорт в barrel.
 */
import { HedgeModeType } from './BybitNative.model'

export interface BitgetTickersModel {
    symbol: string
    lastPrice: number
}

export interface BitgetOrderIdDto {
    orderId: string
}

export interface BitgetPositionDto {
    symbol: string
    leverage: number
    avgPrice: number
    size: number
    liqPrice: number
    unrealisedPnl: number
    positionIdx: HedgeModeType
    side?: BitgetOrderSideTypes
}

export interface BitgetOrderDto {
    orderId: string
    time: number
    symbol: string
    price: number
    size: number
    side: BitgetOrderSideTypes
    type: BitgetOrderTypes
    status: BitgetOrderStatusType
}

export interface BitgetCancelOrderDto {
    orderId: string
    symbol: string
}

export interface BitgetBalanceDto {
    balance: number
}

export interface BitgetLimitDto {
    maxLimit: number
    maxLeverage: number
}

export interface BitgetChangeLeverageDto {
    symbol: string
    leverage: number
}

export interface BitgetGetOrdersHistoryDto {
    symbol: string
}

export interface BitgetOrderHistoryDto {
    orderId: string
    time: number
    symbol: string
    price: number
    size: number
    side: BitgetOrderSideTypes
    commission: number
}

export interface BitgetGetPositionsHistoryDto {
    symbol: string
}

export interface BitgetPositionHistoryDto {
    orderId: number
    time: number
    symbol: string
    size: number
    side: BitgetOrderSideTypes
    pnl: number
    entryPrice: number
    exitPrice: number
}

export interface BitgetGetInstrumentInfoDto {
    symbol: string
    priceStep: number
    quantityStep: number
}

export interface BitgetSwitchPositionModeDto {
    symbol: string
    mode: HedgeModeType
}

export interface BitgetGetPositionDto {
    symbol: string
}

export interface BitgetRiskLimitsDto {
    limits: BitgetLimitDto[]
}

export enum BitgetCandlesIntervalTypes {
    min = '1',
    min3 = '3',
    min5 = '5',
    min15 = '15',
    min30 = '30',
    hour1 = '60',
    hour2 = '120',
    hour4 = '240',
    hour6 = '360',
    hour12 = '720',
    day1 = 'D',
    week1 = 'W',
    mon1 = 'M',
}

export enum BitgetOrderSideTypes {
    Buy = 'Buy',
    Sell = 'Sell',
}

export enum BitgetOrderTypes {
    Limit = 'Limit',
    Market = 'Market',
}

export enum BitgetOrderStatusType {
    Created = 'Created',
    New = 'New',
    Rejected = 'Rejected',
    PartiallyFilled = 'PartiallyFilled',
    Filled = 'Filled',
    Cancelled = 'Cancelled',
    Untriggered = 'Untriggered',
    Triggered = 'Triggered',
    Deactivated = 'Deactivated',
    Active = 'Active',
}

export interface BitgetSendOrderDto {
    symbol: string
    side: BitgetOrderSideTypes
    orderType: BitgetOrderTypes
    positionIdx: HedgeModeType
    size: number
    price?: number
}
